import React from 'react';

import {OrderStatusCssClasses, OrderStatusTitles} from "../../OrdersListUIHelpers";

export function StatusColumnFormatter(cellContent, row){
    const getLabelCssClasses = () =>{
        return `label label-lg label-light-${OrderStatusCssClasses[row.orderStatus]} label-inline`;
    }
    
    return(
        <>
        <span className={getLabelCssClasses()}>
            {OrderStatusTitles[row.orderStatus]}
        </span>
            {row.orderStatus !== 0 && row.approved === false && (
            <span className="label label-lg label-light-danger label-inline mx-2">
                نیاز به تایید تحویل
            </span>
            )}
        </>
    )
}